<template>
  <div id="app">
    <div class="panel">
      <vue-page-stack>
        <router-view :key="$route.fullPath"></router-view>
      </vue-page-stack>
    </div>
    <Navbar v-if="$route.meta.navShow" />
  </div>
</template>

<script>
import Navbar from './components/navbar.vue';
export default {
  components: {
    Navbar
  }
}
</script>

<style lang="scss">
#app {
  display: flex;
  flex-direction: column;

  .panel {
    flex: 1;
    height: 0;
    overflow: scroll;
  }
}

::v-deep .el-scrollbar__wrap {
  overflow: scroll !important;
  -webkit-overflow-scrolling: touch;
}

::v-deep .el-scrollbar__bar.is-vertical {
  display: block !important;
  opacity: 1 !important;
}
</style>
